import { Alert, AlertTitle, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()((theme) => ({
    alert: {
        width: "fit-content",
    },
    alertTitle: {
        margin: 0,
    },
    alertInfo: {
        background: theme.palette.tailwind.sky[50],
        borderRadius: ".5rem",
    },
    alertTitleInfo: {
        color: theme.palette.tailwind.sky[700],
        fontWeight: "normal",
    },
    alertError: {
        background: theme.palette.tailwind.red[600],
        borderRadius: ".25rem",
        "& .MuiAlert-icon": {
            color: theme.palette.common.white,
        },
        "& .MuiAlert-message": {
            color: theme.palette.common.white,
        },
    },
    alertTitleError: {
        color: theme.palette.common.white,
        fontWeight: "normal",
    },
}))

type StandardAlertInfoProps = Readonly<{
    title: string
    icon?: boolean
    className?: string
    severity?: "info" | "error"
}>

export function StandardAlertInfo({ title, icon, className, severity = "info" }: StandardAlertInfoProps) {
    const { classes, cx } = useStyles()

    const alertClass = severity === "error" ? classes.alertError : classes.alertInfo
    const titleClass = severity === "error" ? classes.alertTitleError : classes.alertTitleInfo

    return (
        <Alert severity={severity} icon={icon} className={cx(classes.alert, alertClass, className)}>
            <AlertTitle className={cx(classes.alertTitle, titleClass)}>
                <Typography variant="body2">{title}</Typography>
            </AlertTitle>
        </Alert>
    )
}
